import 'css-chunksrc/client/common/layout/zonesList/zone/loader/styles.scss';export default {
  "projectsList": "_projectsList_1h9e9_1",
  "item": "_item_1h9e9_8"
};